<template>
    <div style="width:100%;">
        <div class="login-title" v-if="step == '1'">
            <span class="item" v-bind:class="{on : btnType === 'person'}" @click="btnType = 'person'">注册用户</span>
            <span class="line">|</span>
            <span class="item" v-bind:class="{on : btnType === 'bus' }" @click="btnType = 'bus'">企业邀请码注册</span>
        </div>
        <div class="login-title" v-if="step == '2'">
            <span class="item on">企业邀请码注册</span>
        </div>
        <registerPerson v-if="btnType === 'person'"></registerPerson>
        <!-- 注册 -->
        <div v-if="btnType === 'bus' && step == '1'">
            <div class="login-input">
                <input v-model="cstName" placeholder="请输入企业名称" @keyup="checkInput('cstName')" maxlength="30"/>
                <span class="login-err" v-show="cstNameErr&&!cstName">企业名称不能为空</span>
                <span class="login-input-length">{{cstName.length}}/30</span>
            </div>
            <div class="login-input">
                <input v-model="cstOrgCode" placeholder="请输入企业的社会信用代码" @keyup="checkInput('cstOrgCode')" maxlength="18"/>
                <span class="login-err" v-show="cstOrgCodeErr">{{cstOrgCode.length==0?"社会信用代码不能为空":"不是有效的社会信用代码"}}</span>
                <span class="login-input-length">{{cstOrgCode.length}}/18</span>
            </div>
            <div class="login-input flexStart">
                <input v-model="inviteCode" placeholder="请输入手机收到的邀请码" @keyup.enter="login" @blur="checkInput('inviteCode')" maxlength="6" style="flex:1;margin-right:30px;"/>
                <div>
                    <button-load @clickHandle="getInviteCode"  type="primary" :disabled="countDisabled" :lable="counter > 0? counter + 's&nbsp;后重新获取' : '重新获取'"></button-load>
                </div>
                <span class="login-err" v-show="inviteCodeErr&&inviteCode.length!=6">{{inviteCode.length==0?"邀请码不能为空":"请输入6位邀请码"}}</span>
                <span class="login-input-length" style="right:156px;">{{inviteCode.length}}/6</span>
            </div>
            <div class="login-input">
                <a-checkbox v-model="isAgree"  style="color:#1890ff;">同意</a-checkbox>
                <a @click="showModal" style="color:#999;">《告知书》</a>
            </div>
            <span class='text-color-red text-size-12' style="position: absolute;">{{errMsg}}</span>
            <div class="login-btn-box">
                <a-button :loading="loadLogin" type="primary" @click="checkRegister" class="login-btn" :disabled="!checkInput()">注册</a-button>
                <div class="login-register"><span @click="toRegister">登 录</span></div>
            </div>
        </div>
        <!-- 设置登录信息 -->
        <div class="step-2" v-if="btnType === 'bus' && step == '2'">
            <register-save></register-save>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { checkRegister,getInviteCode } from "@/api/register";
import { JSEncrypt } from "jsencrypt";
import { systemDate } from "@/api/communal";
import registerSave from "@/components-frame/register-save"
import registerPerson from "@/components-frame/register-person"
export default {
    components: { registerSave,registerPerson },
    data() {
        return {
            btnType:'person',
            step:"1",
            tenantName: "",
            cstName: "",
            cstOrgCode: "",
            inviteCode: "",
            pubKey:
                "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJs93/+qTGnMr68IZoEZjmwlkiJ5lhD+HE6GQMiu/giAjCthA2G8+ri679/FmsryLXqUOEUSYBVmkl2gjmD8XhgYx9BEfO00qhz5uvnhTLNN4RKha8Epsx07EqTm6+LWYdFwuf4MIlKVy3B1YZN9qamyWelXoiDILtf78vFLvnOQIDAQAB",
            encrypt: new JSEncrypt(),
            sequence:"",
            cstNameErr:false,
            cstOrgCodeErr:false,
            inviteCodeErr:false,
            modalShow:false,
            loadLogin:false,
            isAgree:false,
            counter:0,
            countDisabled:false,
            errMsg:"",

            loginName:"",
            loginNameErr:false,
            codeErr:false,
            code:"",
            passwordErr:false,
            password:"",
            confirmPswdErr:false,
            confirmPswd:"",
            emailErr:false,
            email:"",
            checkInfo:{}
        };
    },
    computed: {},
    methods: {
        ...mapMutations({
            setUserObj: "home/setUserObj",
        }),
        checkInput(type){
            switch(type){
                case "cstName":
                this.cstNameErr = (this.cstName.length==0); break;
                case "cstOrgCode":
                this.cstOrgCodeErr = (this.cstOrgCode.length == 0 || !this.utils.creditCode(this.cstOrgCode)); break;
                case "inviteCode":
                this.inviteCodeErr = (this.inviteCode.length!=4); break;
                default:
                return this.cstName.length>0
                && this.utils.creditCode(this.cstOrgCode)
                && this.inviteCode.length==6
                && this.isAgree;
            }
        },
        countTimmer(init){
            if(init) {
                this.countDisabled = true;
                this.counter = 60;
            }
            if(this.counter > 0){
                setTimeout(() => {
                    this.counter --;
                    this.countTimmer();
                },1000)
            }else{
                this.countDisabled = false;
            }
        },
        varyCode() {
            this.sequence = Math.floor(Math.random() * 1e13);
        },
        getInviteCode(btn){
            this.checkInput("cstName");
            this.checkInput("cstOrgCode");
            if(this.cstNameErr || this.cstOrgCodeErr){
                return;
            }
            const param = {
                agree: this.isAgree,
                cstName: this.cstName,
                cstOrgCode: this.cstOrgCode,
                inviteCode: this.inviteCode
            }
            getInviteCode(param).then(res => {
                this.$message.success("邀请码已发送");
                this.countTimmer(init);
                btn.closeLoad();
            }).catch(err => {
                this.errMsg = err.description;
                btn.closeLoad();
            })
        },
        checkRegister() {
            this.loadLogin = true;
            const param = {
                agree: this.isAgree,
                cstName: this.cstName,
                cstOrgCode: this.cstOrgCode,
                inviteCode: this.inviteCode
            }
            checkRegister(param).then(res => {
                this.loadLogin = false;
                this.checkInfo = res.data;
                this.step = '2';
            }).catch(err => {
                this.loadLogin = false;
                this.errMsg = err.description;
            })
        },
        showModal() {
            this.$parent.showModal();
        },
         showPrivacyModal() {
            this.$parent.showPrivacyModal();
        },
        showUserAgreementModal() {
      this.$parent.showUserAgreementModal();
    },
        modalCancel(e) {
            this.modalShow = false;
        },
        toRegister(){
            this.$router.push("/login")
        },
    },
    created() {},
    mounted() {}
}
</script>
<style scoped>

footer{
    position: absolute;
    bottom:0;
    line-height: 40px;
    width: 100%;
    color: #fff;
    background: rgba(0,0,0,0.3);
}
.footer-text{
    width: 80%;
    margin:0 auto;
}
.login-input{
    margin:32px 0 0;
    line-height: 40px;
    position: relative;
}
.step-2 .login-input{
    margin:20px 0 0;
    line-height: 40px;
    position: relative;
}
.login-err{
  position: absolute;
  color:red;
  left: 0;
  bottom: -32px;
  font-size: 12px;
  transition: all ease 0.4s;
}
.login-input input{
    width: 100%;
    border:none;
    outline: none;
    border-bottom:1px solid #ddd;
    line-height: 40px;
    height: 40px;
}
.login-input input:focus{
    border-color: #1990FF;
    transition: border-color 0.5s ease;
    -moz-transition: border-color 0.5s ease;	/* Firefox 4 */
    -webkit-transition: border-color 0.5s ease;	/* Safari 和 Chrome */
    -o-transition: border-color 0.5s ease;
}
.login-input-focus::after{
    content: '';
    display: inline-block;
    width: 100%;
    height: 1px;
    background-color:  #1990FF;
    transition: all 0.5s ease;
}
.login-btn-box{
    margin:16px 0 16px;
    font-size: 14px;
}
.login-btn{
    width: 100%;
    border:none;
    height: 44px;
    font-size: 18px;
}
.login-register{
    color: #1890ff;
    cursor: pointer;
    text-align: center;
    margin-top: 20px;
}
.login-forget{
    color:#999;
    text-decoration: underline;
    cursor: pointer;
}
.login-input-length{
  position: absolute;
  top:6px;
  right: 20px;
  color: #d8d8d8;
  font-size: 12px;
}
.login-title{
    font-weight: bold;
    font-size: 18px;
    text-align: center;
}
.login-title .line{
    margin-left: 15px;
    margin-right: 15px;
}
.login-title .item{
    cursor: pointer;
}
.login-title .item.on{
    color: #1990FF;
}
</style>



// WEBPACK FOOTER //
// src/components-frame/register.vue